import { getBackendUrl } from "../lib/utils";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { getImageUrl } from '../lib/utils';

const mockNewsItems = [
  {
    id: 1,
    title: 'S.S. İkitelli-Silivri Toplu İşyeri Kooperatifi Temel Atma Töreni',
    date: '12 Ağustos 2024',
    image: '/images/renders/render1.jpg',
    summary: 'Silivri\'de yükselecek olan yeni iş merkezimizin temel atma törenini büyük bir coşku ile gerçekleştirdik. Projemizin ilk aşaması başarıyla başladı.'
  },
  {
    id: 2,
    title: 'Yeni Yönetim Kurulu Toplantısı Gerçekleştirildi',
    date: '05 Eylül 2024',
    image: '/images/renders/render2.jpg',
    summary: 'Proje ilerlemesinin değerlendirildiği aylık yönetim kurulu toplantımızda önemli kararlar alındı ve yatırım planları tartışıldı.'
  },
  {
    id: 3,
    title: 'Altyapı Çalışmalarında 1. Etap Tamamlandı',
    date: '20 Ekim 2024',
    image: '/images/renders/render3.jpg',
    summary: 'Kooperatif arazi alanında başlatılan kazı, su, elektrik ve telekomünikasyon altyapı çalışmaları planlanan tarihten önce bitirildi.'
  }
];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const News = () => {
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const backendUrl = getBackendUrl();
        const { data } = await axios.get(`${backendUrl}/api/news`);
        if (data && data.length > 0) {
          setNewsItems(data);
        } else {
          setNewsItems(mockNewsItems);
        }
      } catch (err) {
        setNewsItems(mockNewsItems);
      }
    };
    fetchNews();
  }, []);

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h4 className="text-blue-600 font-semibold uppercase tracking-wider text-sm mb-3">Güncel</h4>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Haberler ve Duyurular</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Kooperatifimizle ilgili son gelişmeler, duyurular ve proje ilerleme süreçlerini buradan takip edebilirsiniz.
          </p>
        </motion.div>

        <motion.div 
          initial="hidden"
          animate="visible"
          variants={{
            visible: { transition: { staggerChildren: 0.15 } }
          }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {newsItems.map((item) => {
            const itemId = item.slug || item.id || item._id;
            return (
              <motion.div 
                key={itemId}
                variants={fadeInUp}
                className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-300 group flex flex-col h-full"
              >
                <div className="h-64 overflow-hidden relative">
                  <div className="absolute inset-0 bg-blue-900/10 group-hover:bg-transparent transition-colors z-10"></div>
                  {item.image ? (
                    <img
                      src={getImageUrl(item.image)}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  ) : (
                    <div className="w-full h-full bg-slate-200 flex items-center justify-center text-slate-400">Görsel Yok</div>
                  )}
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-lg text-xs font-semibold text-slate-700 flex items-center gap-2 z-20">
                    <Calendar size={14} className="text-blue-600" />
                    {item.date}
                  </div>
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-500 text-sm mb-6 line-clamp-3 flex-1">
                    {item.summary}
                  </p>
                  <Link to={`/haberler/${itemId}`} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600 group-hover:text-blue-700">
                    Devamını Oku <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default News;
